export default "__VITE_ASSET__CDmnEqsE__"